import PropTypes from 'prop-types';
import orgUnit from './orgUnit';
import { ActivityPropType } from './activity';
import address from './address';
import timeSlotsPackage from './timeSlotsPackage';

const TreatmentDefaultProps = {
  reviewDate: null,
  address: null,
  orgUnits: null,
  activities: null,
  communityMatron: null,
  emergencyUnscheduled: null,
  patientId: null,
  dateFrom: null,
  dateTo: null,
  specificTimeFrom: null,
  specificTimeTo: null,
  dateClosed: null,
  recurrenceType: null,
  recurEvery: null,
  timeSlotsPackage: null,
  timeSlotsMatrix: null,
  description: null,
  monthlyRecurrenceType: null,
};

const Treatment = PropTypes.shape({
  id: PropTypes.number.isRequired,
  reviewDate: PropTypes.string,
  address,
  orgUnits: PropTypes.arrayOf(orgUnit),
  activities: PropTypes.arrayOf(ActivityPropType),
  communityMatron: PropTypes.bool,
  emergencyUnscheduled: PropTypes.bool,
  patientId: PropTypes.string,
  dateFrom: PropTypes.string,
  dateTo: PropTypes.string,
  specificTimeFrom: PropTypes.string,
  specificTimeTo: PropTypes.string,
  dateClosed: PropTypes.bool,
  recurrenceType: PropTypes.string,
  recurEvery: PropTypes.number,
  timeSlotsPackage,
  timeSlotsMatrix: PropTypes.shape({}),
  description: PropTypes.string,
  monthlyRecurrenceType: PropTypes.string,
  selectedWeeks: PropTypes.arrayOf(PropTypes.string),
  selectedWeekDays: PropTypes.arrayOf(PropTypes.string),
});

export { TreatmentDefaultProps, Treatment };
